<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>勋章配置</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="form-wrapper">
         <el-form label-width="100px" :model="formData" :rules="formRules" ref="formRef">
            <el-form-item label="名称" prop="badgeName">
               <el-input placeholder="输入名称" :maxlength="100" v-model="formData.badgeName"
                  :disabled="actionType === 'detail'">
               </el-input>
            </el-form-item>
            <el-form-item label="成就标识" prop="badgeId">
               <el-input placeholder="输入成就标识" :maxlength="100" v-model="formData.badgeId"
                  :disabled="actionType !== 'add'">
               </el-input>
            </el-form-item>
            <el-form-item label="达成类型">
               <el-select v-model="formData.badgeType" :disabled="actionType !== 'add'">
                  <el-option label="按学期" :value="1"></el-option>
                  <el-option label="按时间" :value="2"></el-option>
                  <el-option label="达成学期目标" :value="3"></el-option>
                  <el-option label="入学年份" :value="4"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="达成条件" prop="reachCondition">
               <div v-if="formData.badgeType == 1" class="flex-row">
                  <div style="width: 74px;">学期内跑步</div>
                  <el-input style="width: 100px;" type="number" :min="0" v-model="formData.lengthLimit"
                     :disabled="actionType === 'detail'">
                  </el-input>
                  <div style="width: 50px;">&nbsp;公里</div>
               </div>
               <div v-if="formData.badgeType == 2" class="flex-row">
                  <el-date-picker placeholder="起始日期" v-model="formData.specialStartDate"
                     :disabled="actionType === 'detail'">
                  </el-date-picker>
                  <div>&nbsp;至&nbsp;</div>
                  <el-date-picker placeholder="截止日期" v-model="formData.specialEndDate"
                     :disabled="actionType === 'detail'">
                  </el-date-picker>
                  <div style="width: 46px;">&nbsp;&nbsp;跑步&nbsp;</div>
                  <el-input style="width:100px;" type="number" :min="0" v-model="formData.timesLimit"
                     :disabled="actionType === 'detail'">
                  </el-input>
                  <div>&nbsp;次</div>
               </div>
               <div v-if="formData.badgeType == 3" class="flex-row-between">
                  <el-date-picker placeholder="起始日期" v-model="formData.startDate" :disabled="actionType === 'detail'">
                  </el-date-picker>
                  <div>&nbsp;至&nbsp;</div>
                  <el-date-picker placeholder="截止日期" v-model="formData.endDate" :disabled="actionType === 'detail'">
                  </el-date-picker>
                  <div>&nbsp;内最长的学期</div>
               </div>
               <div v-if="formData.badgeType == 4" class="flex-row">
                  <div style="width: 60px;">入学年份</div>
                  <el-select style="width: 100px;" v-model="formData.caid">
                     <el-option v-for="(item, index) in yearOptions" :key="index" :label="item" :value="item" />
                  </el-select>
                  <div style="width: 150px;">&nbsp;的学生，首次跑步获得</div>
               </div>
            </el-form-item>
            <el-form-item label="奖牌说明" prop="badgeExplain">
               <el-input placeholder="输入奖牌说明" v-model="formData.badgeExplain" :disabled="actionType === 'detail'">
               </el-input>
            </el-form-item>
            <el-form-item label="H5链接">
               <el-input placeholder="输入H5链接" v-model="formData.clickLink" :disabled="actionType === 'detail'">
               </el-input>
            </el-form-item>
            <el-form-item label="scheme链接" prop="newClickLink">
               <el-input placeholder="输入scheme链接" v-model="formData.newClickLink" :disabled="actionType === 'detail'">
               </el-input>
            </el-form-item>
            <el-form-item label="图形" prop="badgeImage">
               <div class="flex-row-between">
                  <div>
                     <div>勋章图</div>
                     <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=4"
                        tips="(尺寸:200px*200px,jpg、png)" :urls="formData.homeAirdropImage"
                        :readonly="actionType === 'detail'" @onUrls="homeAirdropImageUploaded">
                     </UploadImage>
                  </div>
                  <div>
                     <div>首页弹窗</div>
                     <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=4"
                        tips="(尺寸:200px*200px,jpg、png)" :urls="formData.homeAirdropImageNew"
                        :readonly="actionType === 'detail'" @onUrls="homeAirdropImageNewUploaded">
                     </UploadImage>
                  </div>
               </div>
            </el-form-item>
            <el-form-item label="是否弹窗">
               <el-radio-group v-model="formData.isAirdrop">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="有效时间" prop="effectiveTime">
               <div class="flex-row-between">
                  <el-date-picker placeholder="起始日期" type="datetime" v-model="formData.startTime"
                     :disabled="actionType === 'detail'">
                  </el-date-picker>
                  <div>至</div>
                  <el-date-picker placeholder="截止日期" type="datetime" v-model="formData.endTime"
                     :disabled="actionType === 'detail'">
                  </el-date-picker>
               </div>
            </el-form-item>
         </el-form>
      </div>

      <div class="margin-20" v-if="actionType !== 'detail'">
         <el-button type="primary" @click="clickSave">保存</el-button>
         <el-button type="primary" @click="clickSaveAndPublish">保存并发布</el-button>
      </div>
   </div>
</template>

<script>
import UploadImage from "../../../../components/UploadItems/UploadImage.vue";

export default {
   components: {
      UploadImage
   },

   data() {
      // 验证达成条件
      const validateReachCondition = (rule, value, callback) => {
         if (this.formData.badgeType == 1) {
            if (!this.formData.lengthLimit || this.formData.lengthLimit === '' || this.formData.lengthLimit <= 0) {
               callback(new Error('请输入跑步公里数'));
            } else {
               callback();
            }
         } else if (this.formData.badgeType == 2) {
            if (!this.formData.specialStartDate || this.formData.specialStartDate === '') {
               callback(new Error('请选择起始日期'));
            } else if (!this.formData.specialEndDate || this.formData.specialEndDate === '') {
               callback(new Error('请选择截止日期'));
            } else if (!this.formData.timesLimit || this.formData.timesLimit === '' || this.formData.timesLimit <= 0) {
               callback(new Error('请输入跑步次数'));
            } else {
               const startDate = new Date(this.formData.specialStartDate);
               const endDate = new Date(this.formData.specialEndDate);
               if (startDate.getTime() >= endDate.getTime()) {
                  callback(new Error('起始日期不能大于截止日期'));
               } else {
                  callback();
               }
            }
         } else if (this.formData.badgeType == 3) {
            if (!this.formData.startDate || this.formData.startDate === '') {
               callback(new Error('请选择起始日期'));
            } else if (!this.formData.endDate || this.formData.endDate === '') {
               callback(new Error('请选择截止日期'));
            } else {
               const startDate = new Date(this.formData.startDate);
               const endDate = new Date(this.formData.endDate);
               if (startDate.getTime() >= endDate.getTime()) {
                  callback(new Error('起始日期不能大于截止日期'));
               } else {
                  callback();
               }
            }
         } else if (this.formData.badgeType == 4) {
            if (!this.formData.caid) {
               callback(new Error('请选择入学年份'));
            } else {
               callback();
            }
         }
      };
      // 验证入勋章图
      const validateBadgeImage = (rule, value, callback) => {
         if (!this.formData.homeAirdropImage || this.formData.homeAirdropImage === '') {
            callback(new Error('请选择勋章图'));
         } else if (!this.formData.homeAirdropImageNew || this.formData.homeAirdropImageNew === '') {
            callback(new Error('请选择首页弹窗'));
         } else {
            callback();
         }
      };
      // 验证有效日期
      const validateEffectiveTime = (rule, value, callback) => {
         const startEmpty = !this.formData.startTime || this.formData.startTime === '';
         const endEmpty = !this.formData.endTime || this.formData.endTime === '';
         if (startEmpty && endEmpty) {
            callback();
         } else if (!startEmpty && !endEmpty) {
            const startDate = new Date(this.formData.startTime);
            const endDate = new Date(this.formData.endTime);
            if (startDate.getTime() >= endDate.getTime()) {
               callback(new Error('起始日期不能大于截止日期'));
            } else {
               callback();
            }
         } else {
            callback(new Error('请同时选择起始和截止日期'));
         }
      };
      return {
         loading: false,
         actionType: '',
         id: '',
         formData: {
            badgeName: '',
            badgeId: '',
            badgeType: 1, // 1里程碑 2特殊日期 3达成学期目标
            lengthLimit: '',
            specialStartDate: '',
            specialEndDate: '',
            timesLimit: '',
            startDate: '',
            endDate: '',
            caid: new Date().getFullYear(),
            badgeExplain: '',
            clickLink: '',
            newClickLink: '',
            homeAirdropImage: '',
            homeAirdropImageNew: '',
            isAirdrop: 1,
            startTime: '',
            endTime: '',
            status: '',
         },
         formRules: {
            badgeName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
            badgeId: [{ required: true, message: '请输入成就标识', trigger: 'blur' }],
            reachCondition: [{ required: true, validator: validateReachCondition, trigger: 'blur' }],
            badgeExplain: [{ required: true, message: '请输入奖牌说明', trigger: 'blur' }],
            newClickLink: [{ required: true, message: '请输入链接', trigger: 'blur' }],
            badgeImage: [{ required: true, validator: validateBadgeImage, trigger: 'blur' }],
            effectiveTime: [{ required: false, validator: validateEffectiveTime, trigger: 'blur' }],
         },
      }
   },

   computed: {
      yearOptions() {
         const year = new Date().getFullYear();
         let options = [];
         for (let i = year - 4; i <= year + 1; i++) {
            options.push(i);
         }
         return options;
      }
   },

   mounted() {
      this.actionType = this.$route.query.actionType || '';
      this.id = this.$route.query.id || '';
      this.formData.badgeType = this.$route.query.type || 1;
      if (this.id !== '') {
         this.queryInfo(this.id);
      }
   },

   methods: {
      // 查询信息
      queryInfo(id) {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/badge/config/detail',
            method: 'GET',
            params: { id }
         }).then((res) => {
            if (res.data.error !== 10000) {
               this.$util.errorMsg(res.data.message);
               return;
            }
            const info = res.data.data;
            this.formData.badgeName = info.badgeName;
            this.formData.badgeId = info.badgeId;
            this.formData.badgeExplain = info.badgeExplain;
            this.formData.clickLink = info.clickLink;
            this.formData.newClickLink = info.newClickLink;
            this.formData.badgeId = info.badgeId;
            this.formData.homeAirdropImage = info.homeAirdropImage;
            this.formData.homeAirdropImageNew = info.homeAirdropImageNew;
            this.formData.isAirdrop = info.isAirdrop;
            this.formData.startTime = info.startTime ? new Date(info.startTime) : '';
            this.formData.endTime = info.endTime ? new Date(info.endTime) : '';
            this.formData.status = info.status;
            if (info.badgeType === 1) {
               this.formData.lengthLimit = info.runMilestoneRuleDTO ? info.runMilestoneRuleDTO.lengthLimit / 1000 : '';
            } else if (info.badgeType === 2 && info.specialDateRuleDTO) {
               const dto = info.specialDateRuleDTO;
               this.formData.specialStartDate = dto.specialStartDate ? new Date(dto.specialStartDate) : '';
               this.formData.specialEndDate = dto.specialEndDate ? new Date(dto.specialEndDate) : '';
               this.formData.timesLimit = dto.timesLimit || '';
            } else if (info.badgeType === 3 && info.reachSemesterGoalRuleDTO) {
               const dto = info.reachSemesterGoalRuleDTO;
               this.formData.startDate = dto.startDate ? new Date(dto.startDate) : '';
               this.formData.endDate = dto.endDate ? new Date(dto.endDate) : '';
            } else if (info.badgeType === 4 && info.firstRunCaid) {
               this.formData.caid = info.firstRunCaid.caid;
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送配置
      sendConfig(status) {
         let param = {
            badgeName: this.formData.badgeName,
            badgeId: this.formData.badgeId,
            badgeType: this.formData.badgeType, // 1里程碑 2特殊日期 3达成学期目标
            badgeExplain: this.formData.badgeExplain,
            clickLink: this.formData.clickLink,
            newClickLink: this.formData.newClickLink,
            homeAirdropImage: this.formData.homeAirdropImage,
            homeAirdropImageNew: this.formData.homeAirdropImageNew,
            isAirdrop: this.formData.isAirdrop,
            startTime: '',
            endTime: '',
            status: status,
            badgeCategory: 1,
            imageUrl: '',
         };
         if (this.id && this.id !== '') {
            param['id'] = this.id;
         }
         if (this.formData.badgeType == 1) {
            param['runMilestoneRuleDTO'] = { lengthLimit: this.formData.lengthLimit * 1000 };
         } else if (this.formData.badgeType == 2) {
            param['specialDateRuleDTO'] = {
               specialStartDate: new Date(this.formData.specialStartDate).format('yyyy-MM-dd'),
               specialEndDate: new Date(this.formData.specialEndDate).format('yyyy-MM-dd'),
               timesLimit: this.formData.timesLimit,
            };
         } else if (this.formData.badgeType == 3) {
            param['reachSemesterGoalRuleDTO'] = {
               startDate: new Date(this.formData.startDate).format('yyyy-MM-dd'),
               endDate: new Date(this.formData.endDate).format('yyyy-MM-dd'),
            };
         } else if (this.formData.badgeType == 4) {
            param['firstRunCaid'] = {
               caid: this.formData.caid,
            };
         }
         if (this.formData.startTime) {
            param.startTime = new Date(this.formData.startTime).getTime();
         }
         if (this.formData.endTime) {
            param.endTime = new Date(this.formData.endTime).getTime();
         }
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/badge/config/addOrEdit',
            method: 'POST',
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.data.error === 10000) {
               this.$router.go(-1);
               this.$util.successMsg(res.data.message);
            } else {
               this.$util.errorMsg(res.data.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         })
      },
      // 上传勋章图片
      homeAirdropImageUploaded(image) {
         this.formData.homeAirdropImage = image;
      },
      // 上传首页弹窗图片
      homeAirdropImageNewUploaded(image) {
         this.formData.homeAirdropImageNew = image;
      },
      // 点击保存
      clickSave() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               this.sendConfig(2);
            }
         });
      },
      // 点击保存并发布
      clickSaveAndPublish() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               this.sendConfig(1);
            }
         });
      },
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// MedalConfigAddition.vue?9265024e